import React, { useEffect } from "react";
import "./RegionSelector.css";
import { DefaultButton, Dropdown, IDropdownOption } from "@fluentui/react";
import * as Constants from "@shared/constants";
import { getLocalStorageRegion, regionDataArray } from "@shared";

const options: IDropdownOption[] = regionDataArray.map(({ url, ...keepAttrs }) => keepAttrs);

const RegionSelector: React.FunctionComponent = () => {
  const [selectedItem, setSelectedItem] = React.useState<IDropdownOption>(undefined);

  const onChangeDropDown = (event: React.FormEvent<HTMLDivElement>, item: IDropdownOption): void => {
    setSelectedItem(item);
  };

  useEffect(() => {
    const region = getLocalStorageRegion();
    if (region) {
      const item: IDropdownOption = options.find((el) => el.key === region);
      setSelectedItem(item);
    }
  }, []);

  return (
    <div>
      <Dropdown
        placeholder="Select an option"
        label="Please select region"
        selectedKey={selectedItem ? selectedItem.key : undefined}
        options={options}
        onChange={onChangeDropDown}
      />
      <div className="region-menu">
        <DefaultButton
          disabled={selectedItem === undefined}
          onClick={proceedButtonClick}
          text="Continue with the selected region"
        />
      </div>
    </div>
  );

  function proceedButtonClick(): void {
    localStorage.setItem(Constants.regionLocalStorageKey, selectedItem.key.toString());
    window.location.reload();
  }
};

export default RegionSelector;
